<p><em v-html="field.value"></em></p>